import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import arrow from "../../assets/images/arrow.png";
import icon from "../../assets/images/reviewImg.png";
import shadow from "../../assets/images/shadow-review.png";
import { getAllCustomersReviews } from "../../helper/backend-methods";
import { useEffect } from "react";

// const reviews = [
//   {
//     id: 1,
//     text: "I’ve been ordering from here for over three months now, and I’m honestly impressed every time. The fruits and veggies are always fresh, and the pickup process is super smooth.",
//     name: "Lena Roberts",
//     location: "Oakwood Ave, New York",
//   },
//   {
//     id: 2,
//     text: "Their weekly deals are a lifesaver for families like ours. Great selection, clean packaging, and staff that genuinely cares. I recommend it to all my neighbors!",
//     name: "Jason Miller",
//     location: "Fremont, California",
//   },
//   {
//     id: 3,
//     text: "What I love the most is the quality — especially the meat and pantry items. Everything feels hand-picked and well taken care of. It’s my go-to grocery spot now.",
//     name: "Ayesha Khan",
//     location: "Maple Street, Texas",
//   },
//   {
//     id: 4,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 5,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 6,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 4,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 5,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 6,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 4,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 5,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 6,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 4,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 5,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
//   {
//     id: 6,
//     text: "From snacks to fresh items, everything I ordered was exactly right. No surprises, just good quality and great customer service every time.",
//     name: "Tom Bradley",
//     location: "Lincoln Park, Illinois",
//   },
// ];

export default function CustomerReviews() {

  const [reviews, setReviews] = React.useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await getAllCustomersReviews();
        setReviews(response.data.Data);
      } catch (error) {
        console.error("Error fetching customer reviews:", error);
      }
    };

    fetchReviews();
  }, []);


  return (
    <section id="customer-reviews-section">
      <img src={shadow} className="shadow-right" />
      <div className="wrapper">
        <div className="customer-reviews-header">
          <h2>REVIEWS FROM OUR CUSTOMERS</h2>
          {/* <button type="button">
            VIEW ALL REVIEWS
            <img src={arrow} width={18} height={11} />
          </button> */}
        </div>
      </div>

      <div className="customer-reviews-slider-wrap" id="reviews">
        <Swiper className="customer-reviews-swiper" spaceBetween={20} slidesPerView="auto" loop={false} grabCursor={true}>
          {reviews.map((review, index) => (
            <SwiperSlide key={`${review.Id}-${index}`} className="customer-review-slide">
              <div className="customer-review-card">
                <img src={icon} width={58} height={43} className="review-icon" />
                <p>{review.ReviewText}</p>

                <div className="customer-review-user">
                  <h4>{review.CustomerName}</h4>
                  <span>{review.Location}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
